/**
 * 今日の県を、収録されているステージから決める（STAGES に依存するので daily.ts と分けてある）。
 */

import { ALL_PREFECTURE_IDS } from '../game/config/regions';
import { STAGES, stagePath } from '../game/config/stages';
import { dailyRegionFor, dailySeed, localDateKey } from './daily';

export interface TodaysDaily {
  dateKey: string;
  regionId: string;
  regionName: string;
  stageId: string;
  seed: string;
  /** 例: /fukuoka?daily=2026-09-24 */
  href: string;
  /** 例: 9/24 */
  shortDate: string;
}

export function todaysDaily(now: Date = new Date()): TodaysDaily | null {
  const published = new Map(
    Object.entries(STAGES)
      .filter(([, s]) => !s.draft && !s.parentId)
      .map(([id, s]) => [s.regionId, id] as const),
  );
  const regionIds = ALL_PREFECTURE_IDS.filter((id) => published.has(id));
  if (regionIds.length === 0) return null;
  const dateKey = localDateKey(now);
  const regionId = dailyRegionFor(dateKey, regionIds);
  const stageId = published.get(regionId)!;
  const [, m, d] = dateKey.split('-').map(Number);
  return {
    dateKey,
    regionId,
    regionName: STAGES[stageId].regionName,
    stageId,
    seed: dailySeed(dateKey, regionId),
    href: `${stagePath(stageId)}?daily=${dateKey}`,
    shortDate: `${m}/${d}`,
  };
}
